export enum SavedViewVisibility {
  Private = 'Private',
  SharedToOrg = 'SharedToOrg',
}

export type SavedViewSlice = 'columnVisibility' | 'columnOrder' | 'columnFilters' | 'columnPinning' | 'sorting'

/** Only the slices the creator chose to include are present. */
export type SavedViewConfig = Partial<Record<SavedViewSlice, unknown>>

export interface SavedView {
  id: number
  name: string
  pageKey: string
  visibility: SavedViewVisibility
  config: string
  creatorUserId: number
}

export interface SavedViewSaveModel {
  name: string
  pageKey: string
  visibility: SavedViewVisibility
  config: string
}
